module.exports = __webpack_public_path__ + "static/media/scrubblitz-logo.c76724aa.jpg";